import { render, staticRenderFns } from "./ShCourseList.vue?vue&type=template&id=54efedc6&scoped=true"
import script from "./ShCourseList.vue?vue&type=script&lang=js"
export * from "./ShCourseList.vue?vue&type=script&lang=js"
import style0 from "./ShCourseList.vue?vue&type=style&index=0&id=54efedc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54efedc6",
  null
  
)

export default component.exports